import _ from 'lodash';
import moment from 'moment';
import humps from 'humps';
import sha512 from 'crypto-js/sha512';
import encHex from 'crypto-js/enc-hex';

export default {
  objectKeysToCamelCase(obj) {
    const camelCaseObject = _.isArray(obj) ? [] : {};
    _.forEach(obj, (value, key) => {
      if (_.isPlainObject(value) || _.isArray(value)) {
        camelCaseObject[_.isString(key) ? _.camelCase(key) : key] =
          this.objectKeysToCamelCase(value);
      } else {
        camelCaseObject[_.isString(key) ? _.camelCase(key) : key] = value;
      }
    });
    return camelCaseObject;
  },

  // We use humps.decamelize instead of _.snakeCase because lodash treats numbers as split
  // points, which is different from the backend snakecase logic by guava.
  objectKeysToSnakeCase(obj) {
    const snakeCaseObject = _.isArray(obj) ? [] : {};
    _.forEach(obj, (value, key) => {
      if (_.isPlainObject(value) || _.isArray(value)) {
        snakeCaseObject[_.isString(key) ? humps.decamelize(key) : key] =
          this.objectKeysToSnakeCase(value);
      } else {
        snakeCaseObject[_.isString(key) ? humps.decamelize(key) : key] = value;
      }
    });
    return snakeCaseObject;
  },

  upsertRemoteObjects(remoteObjects, newRemoteObject) {
    const clone = remoteObjects.slice();
    const index = clone.findIndex(el => el.getId() === newRemoteObject.getId());
    if (index >= 0) {
      clone.splice(index, 1, newRemoteObject);
    } else {
      clone.push(newRemoteObject);
    }
    return clone;
  },

  toDateString(momentObj, fallback = '') {
    return momentObj ? momentObj.format('YYYY-MM-DD') : fallback;
  },

  toDateUsString(momentObj, fallback = '') {
    return momentObj ? momentObj.format('MM/DD/YYYY') : fallback;
  },

  toTimeString(momentObj, fallback = '') {
    return momentObj ? momentObj.format('HH:mm') : fallback;
  },

  toDateTimeString(momentObj, fallback = '') {
    return momentObj ? momentObj.format('YYYY-MM-DD HH:mm:ss') : fallback;
  },

  toDateTimeUsString(momentObj, fallback = '') {
    return momentObj ? momentObj.format('MM/DD/YYYY HH:mm:ss') : fallback;
  },

  toDateTimeStringMidNight(momentObj, fallback = '') {
    return momentObj ? momentObj.format('YYYY-MM-DD 00:00:00') : fallback;
  },

  toDateTimeStringEndOfDay(momentObj, fallback = '') {
    return momentObj ? momentObj.format('YYYY-MM-DD 23:59:59') : fallback;
  },

  toArrayString(arr) {
    return arr ? arr.join(',') : null;
  },

  isNumeric(value) {
    if (typeof value === 'number') {
      return true;
    } else {
      return !isNaN(parseFloat(value)) && isFinite(value) && !value.includes('e')/* e.g. 1e+25 */;
    }
  },

  isInteger(value) {
    return this.isNumeric(value) && Number.isInteger(Number(value));
  },

  isPositiveInteger(value) {
    return this.isInteger(value) && Number(value) > 0;
  },

  isNonNegativeInteger(value) {
    return this.isInteger(value) && Number(value) >= 0;
  },

  isValidId(id) {
    return this.isPositiveInteger(id);
  },

  mimeTypeToFileExt(mimeType) {
    switch (mimeType) {
      case 'image/jpeg':
        return 'jpg';
      case 'image/png':
        return 'png';
      case 'image/gif':
        return 'gif';
      case 'image/webp':
        return 'webp';
      case 'image/x-icon':
        return 'ico';
      default:
        return null;
    }
  },

  getHourlyNounce(userId, salt) {
    return encHex.stringify(sha512(
      [userId, moment().utc().format('YYYY-MM-DD HH:00:00'), salt].join('_'))).substring(0, 8);
  },
};
